
import React , { useState , useEffect }  from "react";
import { useSelector  } from "react-redux";

import {  useContrats } from "../../state/reactquery";

import { axios_files_listdocsclientS3 } from "../../axios/axios_files";

import Check from "../Check";
import ContratWinFicSend from "./ContratWinFicSend";
import ContratWinFicContratSend from "./ContratWinFicContratSend";

import ContratWinFicContratUploadTwoFiles from "./ContratWinFicContratUploadTwoFiles";
import ContratWinAlert from "./ContratWinAlert";

import ContratWinContratSend from "./ContratWinContratSend";


import './ContratWinFicContrat.scss' 
const nombulletin  =(compagnie , gamme) =>{
    return(`bulletin`+compagnie+gamme).replace(/(['])/g,"").replace(/(["’ \-+])/g,"").replace(/([é])/g,"e").replace(/([è])/g,"e")+'.pdf' ;
  }
function ContratWinFicContrat(){
    const lead = useSelector(state=>state.lead.leadactu) ;

    const {data: contrats} = useContrats(lead?.email,lead?.courtier) ; 
    const formule = contrats?.filter(c=>c.id_contrat===lead.id_contrat)?.[0] ; 
    const [loadingpage, setLoadingpage] = useState(true) ; 
    const [bulletinexiste, setBulletinexiste] = useState(true) ;
    const [choice, setChoice] = useState(0) ; 


    const alert = lead.sign_coord!==2  || lead.sign_formule!==2  ;
    
    async function fetchBulletinsAndTest() {
        const res = await axios_files_listdocsclientS3('bulletins') ; 
        const test =res.data?.map(x=>x?.replace('bulletins/',''))?.includes(nombulletin(formule?.compagnie,formule?.gamme)) ;
        setBulletinexiste(test?true : false ) ;
        setLoadingpage(false) ;
    } 

    useEffect(()=>{  fetchBulletinsAndTest();     },[formule?.compagnie]) ;

    return(<>{alert ? <ContratWinAlert etape='etape_bulletin'
                                        nocoords = {lead.sign_coord!==2} 
                                        noformule ={lead.sign_formule!==2}  />:<>
        <>{loadingpage?<></>  :
            <> 
            <div className="contratwin_left_titre" >Fiche Info & Conseils, contrat et documents légaux.</div>
            <div className='ficheconseil_textetop'>Pour être en conformité avec l’article L521-4 du Code des assurances, vous devez faire signer cette fiche par le client.</div>
            <div className="bulletinfic_choix"><Check checked={choice===0} onclick={()=>setChoice(0)}  /><div><span>Signer la Fiche Conseil</span> avec Signassur </div></div>
            {bulletinexiste && <div className="bulletinfic_choix"><Check checked={choice===1} onclick={()=>setChoice(1)}  /><div><span>Signer le Bulletin</span> avec Signassur</div> </div>}
            {bulletinexiste && <div className="bulletinfic_choix"><Check checked={choice===2} onclick={()=>setChoice(2)}  /><div><span>Signer Bulletin + FIC</span> avec Signassur</div> </div>}
            {/* <div className="bulletinfic_choix"><Check checked={choice===2} onclick={()=>setChoice(2)} /><div><span>Bulletin + FIC  déjà signé</span> en un seul document</div></div> */}
            <div className="bulletinfic_choix"><Check checked={choice===3} onclick={()=>setChoice(3)} /><div><span>Bulletin + FIC déjà signés</span> en deux documents séparés</div></div>
            {choice===0?<ContratWinFicSend />:
            choice===1?<ContratWinContratSend />:
            choice===2?<ContratWinFicContratSend />:
                        <ContratWinFicContratUploadTwoFiles />}
        </>  }</></>}</>
        
    );
}

export default ContratWinFicContrat ;

